import React from "react";
import { Link, useLocation } from "react-router-dom";
import SectionHeading from "../SectionHeading/SectionHeading";
import styles from "./Note.module.scss";
import loginPattern from "../../assets/login-pattern.png";
import { Logo } from "../Symbols/Symbols";
import { queryParameters } from "../../helpers/helpers";

export default function Note({ accountDeletion }) {
  let location = useLocation();
  let title = location.state && location.state.title;
  let msg = location.state && location.state.msg;

  const searchParams = location.search && queryParameters(location.search);
  if (searchParams && searchParams.account_confirmation_success) {
    title = "";
    msg = searchParams.account_confirmation_success === "false" ? "Sähköpostiosoite on jo vahvistettu tai tämä linkki on vanhentunut. " : "Sähköpostisi on varmistettu! ";
  }

  return (
    <div className={styles.screenContainer}>
      <div className={styles.formContainer}>
        <div className={styles.title}>
          <h1>Heta</h1>
        </div>
        <div className={styles.text}>
          {accountDeletion ? (
            <>
              <p>Ohjeet henkilötietojen poistamiseen Heta-sovelluksesta.</p>
              <br />
              <p>Mikäli haluat henkilötietosi poistettavan Heta-sovelluksesta, lähetä pyyntö sähköpostilla osoitteeseen <a href="mailto:heta-sovellus@hekaoy.fi">heta-sovellus@hekaoy.fi</a>. Pyynnön myötä kaikki henkilötietosi poistetaan.</p>
              <br />
              <p>Käyttäjätilisi poistaminen ei poista sovellukseen tuottamaasi sisältöä.</p>
              <br />
              <div>
                <span>{msg} </span>
                <Link to="/">Kirjaudu sisään</Link>
              </div>
            </>
          ) : (
          msg ? (
            <>
              {title && (
                <>
                  <SectionHeading>{title}</SectionHeading>
                  <br />
                </>
              )}
              <div>
                <span>{msg} </span>
                <Link to="/">Kirjaudu sisään</Link>
              </div>
            </>
          ) : (
            <Link to="/" className="hyperlink">
              Siirry sovellukseen
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
